import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tagged_text = _resolveComponent("tagged-text");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_wrap_with_section_item = _resolveComponent("wrap-with-section-item");
  return _openBlock(), _createBlock(_component_wrap_with_section_item, {
    selected: $props.selected,
    onSelect: _cache[0] || (_cache[0] = $event => _ctx.$emit('select', {
      id: $props.id
    })),
    onDeselect: _cache[1] || (_cache[1] = $event => _ctx.$emit('deselect', {
      id: $props.id
    })),
    onSelectOnly: _cache[2] || (_cache[2] = $event => _ctx.$emit('selectOnly', {
      id: $props.id
    }))
  }, {
    default: _withCtx(() => [_createVNode(_component_flex_row, {
      gap: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_tagged_text, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($props.segment), 1)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["selected"]);
}